import { render, staticRenderFns } from "./select.tag.component.vue?vue&type=template&id=4112ad2a&scoped=true&lang=pug"
import script from "./select.tag.component.vue?vue&type=script&lang=ts"
export * from "./select.tag.component.vue?vue&type=script&lang=ts"
import style0 from "./select.tag.component.vue?vue&type=style&index=0&id=4112ad2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4112ad2a",
  null
  
)

export default component.exports